import UnorderedList from './src/UnorderedList'
import OrderedList from './src/OrderedList'
import ListItem from './src/ListItem'

export {
  UnorderedList,
  UnorderedList as Ul,
  OrderedList,
  OrderedList as Ol,
  ListItem,
  ListItem as Li
}

export { default as Text } from './src/Text'
export { default as Paragraph } from './src/Paragraph'
export { default as Heading } from './src/Heading'
export { default as Code } from './src/Code'
export { default as Pre } from './src/Pre'
export { default as Label } from './src/Label'
export { default as Link } from './src/Link'
export { default as Small } from './src/Small'
export { default as Strong } from './src/Strong'
